import { Observable } from 'rxjs';

export interface DashboardParams {
  year: number | string,
  campus: number | string
}

export interface ApiResponse {
  code: number,
  message: any
}

export abstract class DashboardData {
  abstract getBUR(params: DashboardParams): Observable<ApiResponse>;
  abstract getOverAllOperatingBudget(params: DashboardParams): Observable<ApiResponse>;
}
